<template>
  <hm-col :id="$attrs['id']" cols="12">
    <blockquote class="blockquote blockquote--quote">
      <slot>
        <p>{{ text || $t(`quotes.quote${quote}.quote`) }}</p>
      </slot>
      <cite>{{ cite || $t(`quotes.quote${quote}.author`) }}</cite>
    </blockquote>
  </hm-col>
</template>

<script>

import { isNil, isEmpty } from 'lodash';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'Quote',

  mixins: [GridMixin],

  props: {
    text: {
      type: String,
      default: null,
    },
    cite: {
      type: String,
      default: null,
    },
  },

  data: function () {
    return {
      quote: 1,
    };
  },

  created: function () {
    this.quote = Math.ceil(Math.random() * 19);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .blockquote {
    padding: 0 2.5rem;
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
    pointer-events: none;

    cite {
      color: $gray;
      position: relative;
      margin-left: 25px;
      &:before {
        position: absolute;
        content: ' ';
        left: -25px;
        width: 20px;
        height: 1px;
        top: calc(50% - 1px);
        background: $mint;
      }
    }

    p {
      margin-top: 5.5rem;
      font-size: 1.7rem;
      text-align: center;
    }

    &::after {
      content:"\201c";
      top: 0px;
      left: 50%;
      position: absolute;
      font-size: 14rem;
      line-height: 12rem;
      height: 50px;
      transform: translateX(-50%);
      color: $mint;
    }
  }
</style>

<style lang="scss">
  .blockquote {
    &--quote {
      p {
        margin-top: 5.5rem;
        font-size: 1.7rem;
        text-align: center;
      }
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/Quote.vue